const VERSION = '2.0.4b'
export default VERSION
